module.exports = __webpack_public_path__ + "travel.svg?4136a9d4501aec9ab9a24c6e2b0f7f16";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/travel.svg
// module id = 140
// module chunks = 0